import { useCallback } from "react";

import { DatatableState } from "../../models/datatable-state-model";

import { useCreateActiveView } from "./use-create-active-view";
import { useUpdateActiveView } from "./use-update-active-view";

export interface UseCreateActiveViewProps {
  activeViewId: string | null | undefined;
  workspaceId: string;
  viewKey: string;
}

export const useSaveDatatableState = ({ activeViewId, workspaceId, viewKey }: UseCreateActiveViewProps) => {
  const { updateActiveView } = useUpdateActiveView();
  const { createActiveView } = useCreateActiveView();

  const saveDatatableState = useCallback(
    (newDatatableState: DatatableState) => {
      if (!activeViewId) {
        void createActiveView({
          ...newDatatableState,
          workspaceId,
          key: viewKey,
        });
      }

      if (activeViewId) {
        void updateActiveView({
          id: activeViewId,
          ...newDatatableState,
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeViewId, workspaceId, viewKey],
  );

  return {
    saveDatatableState,
  };
};
